<!--
 * @Author: Cathy
 * @Date: 2020-02-24 10:00:48
 * @LastEditors: yezi
 * @LastEditTime: 2020-07-16 16:41:33
 * @Description: 联吧下载
 -->

<template>
  <div style="height: 100%">
    <div class="inner">
      <catalogue :list="list"
                 v-if="tabActive == 1" />
      <div class="top_tab">
        <div class="tab"
             v-for="(item,index) in tab"
             :key="index"
             @click.stop="tabClick(index)"
             :class="{'activ_tab':tabActive == index}">{{item}}</div>
        <!-- <div class="tab activ_tab"></div> -->
      </div>
      <label v-if="tabActive == 1"
             style="flex: auto;display:flex; flex-direction: column; overflow:hidden">
        <div class="top_bar">
          <div class="box"
               :class="{'active_bar':active == index}"
               v-for="(item, index) in barList"
               :key="index"
               @click.stop="barClick(index)"
               :style="'background:' + (active == index?item.bgcolor:'') + '!important;'">{{item.names}}</div>
        </div>
        <div class="title_box">
          <div class="title"
               @click.stop="goBack(num)"
               v-if="barList[active]">
            <van-icon name="arrow-left"
                      size="16" />返回
          </div>
        </div>
        <div class="big_box"
             @scroll.passive="scroll($event)">
          <div class="detail">
            <div class="tItem"
                 v-for="(item, index) in list"
                 :key="index"
                 @click.stop="directionsDetail(item.instructions_id,item.type)">
              <img :src="item.type == 1 || item.type == 4 ?item.video_page:item.pt_page" />
              <a :id="'title'+ index" />
              <p>{{index + 1}}.{{item.title}}</p>
              <!-- <div v-html="item.content" style="margin-top: 0.4rem"></div> -->
            </div>
          </div>

        </div>
      </label>
      <label v-else
             style="flex: 1; display:flex; flex-direction: column; overflow:hidden">
        <div class="productList"
             v-if="!show">
          <img v-for="(item, index) in imgList"
               :key="index"
               :src="item.sources"
               @click.stop="onToDetail(item.content)" />
        </div>
        <div class="describe"
             v-else
             v-html="content"></div>
      </label>
      <down v-if="tabActive == 1 || show"></down>
    </div>

  </div>
</template>

<script>
import { getWapSeriasList, getWapList, getList } from '../api/wap'
import store from '@/store/index.js'
import catalogue from '../components/catalogue'
import down from '@/components/down'
export default {
  components: {
    catalogue,
    down
  },
  data () {
    return {
      barList: [],
      active: 0,
      page: 1,
      page_total: 1,
      list: [],
      name: '',
      id: '',
      first: '',
      cate_level: 2,
      imgList: [],
      tab: ['产品介绍', '电机说明'],
      tabActive: 1,
      num: -1,
      show: false,
      content: ''
    }
  },
  store,
  created () {
    this.getBar()
    if (this.$route.query.index) this.active = this.$route.query.index
    if (this.$route.query.id) this.id = this.$route.query.id
    if (this.$route.query.cate_level) this.cate_level = this.$route.query.cate_level
    if (this.$route.query.num) this.num = this.$route.query.num || -1
    this.onLoadData()
  },
  methods: {
    barClick (index) {
      // console.log(111)
      // console.log(this.num)
      this.$store.commit('check', index)
      // console.log(this.$store)
      // alert(JSON.stringify(this.$store));
      if (this.num === -1) {
        this.$router.back(-1)
      } else {
        this.$router.go(this.num)
      }

      // alert(JSON.stringify(this.$router));
    },
    getBar () {
      getWapSeriasList({}).then(res => {
        this.barList = res.result.series_data
        this.getlist()
      })
    },
    getlist () {
      getWapList({
        page_now: this.page,
        cate_id: this.id,
        cate_level: this.cate_level
      }).then(res => {
        if (this.page === 1) {
          this.list = res.result
        } else {
          this.list.push(...res.result)
        };
        this.page_total = res.page_total
        // console.log(this.list)
      })
    },
    toLink (id, name) {
      this.$router.push({
        path: '/newDetailList',
        query: {
          id: id,
          name: name,
          first: this.name
        }
      })
    },
    directionsDetail (id, type) {
      if (type === 2 || type === '2' || type === 5 || type === '5') {
        this.$router.push({
          path: '/videoDetail',
          query: {
            id: id
          }
        })
      } else {
        this.$router.push({
          path: '/directionsDetail',
          query: {
            id: id
          }
        })
      }
    },
    goBack () {
      this.$router.back()
    },
    scroll (e) {
      let bottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight
      if (bottom === 0) {
        if (this.page < this.page_total) {
          this.page++
          this.getlist()
        }
      }
    },
    onLoadData () {
      getList({ type: 3 })
        .then(res => {
          this.imgList = res.result.list
        })
    },
    tabClick (index) {
      this.tabActive = index
    },
    onToDetail (e) {
      this.content = e.replace(/<h1/g, "<h1 style='font-size: .32rem !important'")
      this.show = true
    }
  }
}
</script>

<style scoped>
.downloadImage {
  /* margin-top: 1rem; */
  text-align: center;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0.2rem 0;
  background: #f3f3f3;
}
.downloadImage img {
  width: 6.5rem;
  height: 1.4rem;
}
/* .download {
  height: 100vh;
  background-color: #f3f3f3;
  display: flex;
  flex-direction: column;
} */
.inner {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f3f3f3;
}
.top_tab {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: #333;
}
.tab {
  flex: 1;
  text-align: center;
  font-size: 0.3rem;
  line-height: 0.8rem;
  color: #999;
}
.activ_tab {
  color: #fff;
}
.top_bar {
  padding: 0.2rem 0.5rem;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.box {
  width: 1.3rem;
  height: 1.3rem;
  text-align: center;
  color: #4a4a4a;
  border: 1px solid #4a4a4a;
  font-size: 0.28rem;
  display: flex;
  align-items: center;
  justify-content: center;
  /* white-space: nowrap; */
  border-radius: 0.1rem;
  white-space: wrap;
}
.active_bar {
  color: #fff !important;
  border: none !important;
}
.title_box {
  line-height: 0.7rem;
  font-size: 0.28rem;
  padding-left: 0.4rem;
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
}
.title {
  max-width: 33.3%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
}
.big_box {
  flex: 1;
  /* background: red; */
  overflow: auto;
  background-color: #fff;
}
.big_box >>> .van-cell {
  align-items: center;
  font-size: 0.28rem !important;
  line-height: 0.4rem;
}
.detail {
  padding: 0.3rem 0.1rem;
  display: flex;
  flex-wrap: wrap;
  background: #fff;
}
.detailItem {
  margin-top: 0.4rem;
  padding: 0.4rem;
  border-radius: 0.16rem;
  box-shadow: 0 0 0.46rem 0 rgba(4, 0, 0, 0.13);
}
.detailItem p {
  color: #121212;
  font-size: 0.34rem;
  font-weight: bold;
}
.tItem {
  /* margin-top: 0.59rem; */
  width: 3.45rem;
  border: 1px solid rgba(188, 188, 188, 1);
  border-radius: 0.1rem;
  margin-left: 0.1rem;
  margin-right: 0.1rem;
  padding-bottom: 0.2rem;
  margin-bottom: 0.2rem;
}
.tItem p {
  color: #121212;
  font-size: 0.26rem;
  padding: 0 0.2rem 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.tItem img {
  width: 100%;
  height: 1.95rem;
  background-color: #121212;
}
.productList img {
  margin-top: 0.3rem;
  width: 100%;
  border-radius: 0.16rem;
}
.productList {
  padding: 0 0.2rem;
  overflow: auto;
  flex: 1;
}
.describe {
  padding: 0 0.2rem;
  font-size: 0.28rem;
}
</style>
